var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleMhcv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3780_6252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27C54 41.9117 41.9117 54 27 54Z",
    fill: "#6EB1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8006 16.5605H35.5825V33.1743H2.8006V16.5605Z",
    fill: "#646B79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4823 17.6328H34.2886V32.0929H33.4823V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2225 17.6328H32.0288V32.0929H31.2225V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9628 17.6328H29.769V32.0929H28.9628V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.703 17.6328H27.5093V32.0929H26.703V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4432 17.6328H25.2495V32.0929H24.4432V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1835 17.6328H22.9897V32.0929H22.1835V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9237 17.6328H20.73V32.0929H19.9237V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6639 17.6328H18.4702V32.0929H17.6639V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4047 17.6328H16.2109V32.0929H15.4047V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1449 17.6328H13.9512V32.0929H13.1449V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8851 17.6328H11.6914V32.0929H10.8851V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62535 17.6328H9.43164V32.0929H8.62535V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36559 17.6328H7.17188V32.0929H6.36559V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10583 17.6328H4.91211V32.0929H4.10583V17.6328Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8009 33.1758H36.23V35.6159H2.8009V33.1758Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2299 20.8359H41.545C42.3088 20.8359 43.009 21.2709 43.3379 21.9605L45.0778 25.6206C45.4067 26.3102 46.1069 26.7452 46.8707 26.7452H49.2153C50.3081 26.7452 51.1992 27.6363 51.1992 28.7291V35.6143H36.2299V20.8359Z",
    fill: "#F0582F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6564 21.9082H41.5448C41.8949 21.9082 42.2132 22.1098 42.3617 22.4174L44.1122 26.0776C44.2183 26.3003 44.3456 26.4913 44.4941 26.6717H39.667V21.9082H39.6564Z",
    fill: "#6EB1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3117 21.9082H38.9561V26.6823H37.3117V21.9082Z",
    fill: "#6EB1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2299 33.1738H51.1992V35.6139H36.2299V33.1738Z",
    fill: "#414753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2298 20.836H41.5449C41.5449 20.836 41.0569 17.9822 36.2298 16.5605V20.836Z",
    fill: "#D54232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0831 34.7453C43.0831 32.9099 44.579 31.4141 46.4144 31.4141C48.2497 31.4141 49.7456 32.8993 49.7456 34.7453C49.7456 35.053 49.7032 35.3394 49.6289 35.6152H43.2104C43.1256 35.3394 43.0831 35.0424 43.0831 34.7453Z",
    fill: "#0A173C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4147 37.4402C44.9264 37.4402 43.72 36.2337 43.72 34.7455C43.72 33.2572 44.9264 32.0508 46.4147 32.0508C47.9029 32.0508 49.1094 33.2572 49.1094 34.7455C49.1094 36.2337 47.9029 37.4402 46.4147 37.4402Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4145 36.76C45.3012 36.76 44.3987 35.8575 44.3987 34.7442C44.3987 33.631 45.3012 32.7285 46.4145 32.7285C47.5277 32.7285 48.4302 33.631 48.4302 34.7442C48.4302 35.8575 47.5277 36.76 46.4145 36.76Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4147 36.3161C45.5476 36.3161 44.8446 35.6131 44.8446 34.7459C44.8446 33.8788 45.5476 33.1758 46.4147 33.1758C47.2819 33.1758 47.9849 33.8788 47.9849 34.7459C47.9849 35.6131 47.2819 36.3161 46.4147 36.3161Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4146 35.1805C46.1744 35.1805 45.9797 34.9857 45.9797 34.7455C45.9797 34.5053 46.1744 34.3105 46.4146 34.3105C46.6549 34.3105 46.8496 34.5053 46.8496 34.7455C46.8496 34.9857 46.6549 35.1805 46.4146 35.1805Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.136 34.2885C46.9954 34.2885 46.8814 34.1745 46.8814 34.0339C46.8814 33.8933 46.9954 33.7793 47.136 33.7793C47.2766 33.7793 47.3906 33.8933 47.3906 34.0339C47.3906 34.1745 47.2766 34.2885 47.136 34.2885Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6824 35.7417C45.5418 35.7417 45.4278 35.6277 45.4278 35.487C45.4278 35.3464 45.5418 35.2324 45.6824 35.2324C45.823 35.2324 45.937 35.3464 45.937 35.487C45.937 35.6277 45.823 35.7417 45.6824 35.7417Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6824 34.2885C45.5418 34.2885 45.4278 34.1745 45.4278 34.0339C45.4278 33.8933 45.5418 33.7793 45.6824 33.7793C45.823 33.7793 45.937 33.8933 45.937 34.0339C45.937 34.1745 45.823 34.2885 45.6824 34.2885Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.136 35.7417C46.9954 35.7417 46.8814 35.6277 46.8814 35.487C46.8814 35.3464 46.9954 35.2324 47.136 35.2324C47.2766 35.2324 47.3906 35.3464 47.3906 35.487C47.3906 35.6277 47.2766 35.7417 47.136 35.7417Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2957 31.4141C18.1311 31.4141 19.627 32.8993 19.627 34.7453C19.627 35.053 19.5845 35.3394 19.5103 35.6152H13.0918C13.0175 35.3394 12.9751 35.0424 12.9751 34.7453C12.9645 32.8993 14.4604 31.4141 16.2957 31.4141Z",
    fill: "#0A173C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2955 37.4402C14.8073 37.4402 13.6008 36.2337 13.6008 34.7455C13.6008 33.2572 14.8073 32.0508 16.2955 32.0508C17.7838 32.0508 18.9902 33.2572 18.9902 34.7455C18.9902 36.2337 17.7838 37.4402 16.2955 37.4402Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2953 36.76C15.1821 36.76 14.2796 35.8575 14.2796 34.7442C14.2796 33.631 15.1821 32.7285 16.2953 32.7285C17.4086 32.7285 18.311 33.631 18.311 34.7442C18.311 35.8575 17.4086 36.76 16.2953 36.76Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2956 36.3141C15.4284 36.3141 14.7254 35.6111 14.7254 34.744C14.7254 33.8768 15.4284 33.1738 16.2956 33.1738C17.1627 33.1738 17.8657 33.8768 17.8657 34.744C17.8657 35.6111 17.1627 36.3141 16.2956 36.3141Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2955 35.1805C16.0553 35.1805 15.8605 34.9857 15.8605 34.7455C15.8605 34.5053 16.0553 34.3105 16.2955 34.3105C16.5357 34.3105 16.7305 34.5053 16.7305 34.7455C16.7305 34.9857 16.5357 35.1805 16.2955 35.1805Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0276 34.2885C16.887 34.2885 16.773 34.1745 16.773 34.0339C16.773 33.8933 16.887 33.7793 17.0276 33.7793C17.1682 33.7793 17.2822 33.8933 17.2822 34.0339C17.2822 34.1745 17.1682 34.2885 17.0276 34.2885Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.574 35.7417C15.4334 35.7417 15.3194 35.6277 15.3194 35.487C15.3194 35.3464 15.4334 35.2324 15.574 35.2324C15.7146 35.2324 15.8286 35.3464 15.8286 35.487C15.8286 35.6277 15.7146 35.7417 15.574 35.7417Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.574 34.2885C15.4334 34.2885 15.3194 34.1745 15.3194 34.0339C15.3194 33.8933 15.4334 33.7793 15.574 33.7793C15.7146 33.7793 15.8286 33.8933 15.8286 34.0339C15.8286 34.1745 15.7146 34.2885 15.574 34.2885Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0276 35.7417C16.887 35.7417 16.773 35.6277 16.773 35.487C16.773 35.3464 16.887 35.2324 17.0276 35.2324C17.1682 35.2324 17.2822 35.3464 17.2822 35.487C17.2822 35.6277 17.1682 35.7417 17.0276 35.7417Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45245 31.4141C11.2878 31.4141 12.7837 32.8993 12.7837 34.7453C12.7837 35.053 12.7413 35.3394 12.667 35.6152H6.24852C6.17426 35.3394 6.13182 35.0424 6.13182 34.7453C6.13182 32.8993 7.61709 31.4141 9.45245 31.4141Z",
    fill: "#0A173C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45277 37.4402C7.96453 37.4402 6.75807 36.2337 6.75807 34.7455C6.75807 33.2572 7.96453 32.0508 9.45277 32.0508C10.941 32.0508 12.1475 33.2572 12.1475 34.7455C12.1475 36.2337 10.941 37.4402 9.45277 37.4402Z",
    fill: "#393D47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45254 36.76C8.33929 36.76 7.43683 35.8575 7.43683 34.7442C7.43683 33.631 8.33929 32.7285 9.45254 32.7285C10.5658 32.7285 11.4683 33.631 11.4683 34.7442C11.4683 35.8575 10.5658 36.76 9.45254 36.76Z",
    fill: "#333842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45281 36.3141C8.58565 36.3141 7.88267 35.6111 7.88267 34.744C7.88267 33.8768 8.58565 33.1738 9.45281 33.1738C10.32 33.1738 11.0229 33.8768 11.0229 34.744C11.0229 35.6111 10.32 36.3141 9.45281 36.3141Z",
    fill: "#F1F3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45272 35.1805C9.2125 35.1805 9.01775 34.9857 9.01775 34.7455C9.01775 34.5053 9.2125 34.3105 9.45272 34.3105C9.69295 34.3105 9.8877 34.5053 9.8877 34.7455C9.8877 34.9857 9.69295 35.1805 9.45272 35.1805Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1848 34.2885C10.0442 34.2885 9.93022 34.1745 9.93022 34.0339C9.93022 33.8933 10.0442 33.7793 10.1848 33.7793C10.3255 33.7793 10.4395 33.8933 10.4395 34.0339C10.4395 34.1745 10.3255 34.2885 10.1848 34.2885Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73122 35.7417C8.5906 35.7417 8.4766 35.6277 8.4766 35.487C8.4766 35.3464 8.5906 35.2324 8.73122 35.2324C8.87184 35.2324 8.98584 35.3464 8.98584 35.487C8.98584 35.6277 8.87184 35.7417 8.73122 35.7417Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.73122 34.2885C8.5906 34.2885 8.4766 34.1745 8.4766 34.0339C8.4766 33.8933 8.5906 33.7793 8.73122 33.7793C8.87184 33.7793 8.98584 33.8933 8.98584 34.0339C8.98584 34.1745 8.87184 34.2885 8.73122 34.2885Z",
    fill: "#BDBDBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1848 35.7417C10.0442 35.7417 9.93022 35.6277 9.93022 35.487C9.93022 35.3464 10.0442 35.2324 10.1848 35.2324C10.3255 35.2324 10.4395 35.3464 10.4395 35.487C10.4395 35.6277 10.3255 35.7417 10.1848 35.7417Z",
    fill: "#BDBDBE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3780_6252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "matrix(-1 0 0 1 54 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleMhcv);
export default __webpack_public_path__ + "static/media/VehicleM&HCV.4736cf65eeac627715fd11dbd739ee1c.svg";
export { ForwardRef as ReactComponent };